export default "__VITE_ASSET__Ddyyuk4Y__"